import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isLight, setIsLight] = useState(() => {
    const saved = localStorage.getItem('arden-theme');
    return saved === 'light';
  });

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (isLight) {
      html.classList.remove('dark');
      body.classList.remove('bg-background-dark', 'text-white');
      body.classList.add('bg-background-light', 'text-gray-900');
    } else {
      html.classList.add('dark');
      body.classList.remove('bg-background-light', 'text-gray-900');
      body.classList.add('bg-background-dark', 'text-white');
    }

    localStorage.setItem('arden-theme', isLight ? 'light' : 'dark');
  }, [isLight]);

  const toggleTheme = () => setIsLight((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ isLight, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
